import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const InstrumentChangeConfirmDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  changeType, // 'stringToNonString' or 'nonStringToString'
  oldInstrumentName,
  newInstrumentName
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const getDialogContent = () => {
    if (changeType === 'stringToNonString') {
      return {
        title: 'String to Non-String Instrument Change',
        titleChinese: '“弦乐”乐器到"非弦乐"乐器的变更',
        message: 'You are switching from a string instrument to a non-string instrument. This will permanently remove your answers to string-specific question (e.g. “String Articulation Techniques (弦乐技法)”). Do you want to continue?',
        messageChinese: '您正在将该轨道使用的乐器从一个“弦乐”乐器切换为一个“非弦乐”乐器。此操作将永久删除在该轨道上, 您对弦乐乐器专属问题(例如“String Articulation Techniques (弦乐技法)”)的回答。请问您是否选择继续？',
        confirmButtonText: 'Continue and Remove String Data',
        confirmButtonTextChinese: '继续并删除弦乐数据'
      };
    } else if (changeType === 'nonStringToString') {
      return {
        title: 'Non-String to String Instrument Change',
        titleChinese: '"非弦乐"乐器到“弦乐”乐器的变更',
        message: 'You are switching from a non-string instrument to a string instrument. This will add a new question regarding "String Articulation Techniques (弦乐技法)" to all annotation forms on this track. Thus, every submitted annotation block will be marked as incomplete and must be re-annotated. Do you want to continue?',
        messageChinese: '您正在将该轨道使用的乐器从一个“非弦乐”乐器切换为一个“弦乐”乐器。此操作将使该轨道的所有标注表单新增一个关于“String Articulation Techniques (弦乐技法)”的问题。因此，该轨道上所有已提交的标注方块将被标记为未完成的标注方块，必须重新标注并提交。请问您是否选择继续？',
        confirmButtonText: 'Continue and Mark Incomplete',
        confirmButtonTextChinese: '继续并标记方块为未完成'
      };
    }
    return null;
  };

  const content = getDialogContent();
  
  if (!content) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="instrument-change-dialog-title"
      aria-describedby="instrument-change-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="instrument-change-dialog-title">
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          <Box>
            <div>{content.title}</div>
            <div style={{ fontSize: '14px', color: '#666', fontWeight: 'normal' }}>
              {content.titleChinese}
            </div>
          </Box>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText id="instrument-change-dialog-description" component="div">
          <div style={{ marginBottom: '16px' }}>
            <strong>From:</strong> {oldInstrumentName} <br />
            <strong>To:</strong> {newInstrumentName}
          </div>
          
          <div style={{ marginBottom: '12px', lineHeight: '1.5' }}>
            {content.message}
          </div>
          
          <div style={{ color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
            {content.messageChinese}
          </div>
        </DialogContentText>
      </DialogContent>
      
      <DialogActions style={{ padding: '16px 24px' }}>
        <Button 
          onClick={handleCancel} 
          variant="outlined"
          style={{
            borderColor: '#999',
            color: '#555',
            borderRadius: '8px',
            fontWeight: '500',
            textTransform: 'none'
          }}
        >
          Cancel (取消)
        </Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained"
          style={{
            backgroundColor: '#ef4444',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '500',
            textTransform: 'none'
          }}
          autoFocus
        >
          {content.confirmButtonText}
          <br />
          <span style={{ fontSize: '12px', opacity: 0.9 }}>
            ({content.confirmButtonTextChinese})
          </span>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InstrumentChangeConfirmDialog;
